import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-appointment',
  templateUrl: './review-appointment.component.html',
  styleUrls: ['./review-appointment.component.css']
})
export class ReviewAppointmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
